export default __webpack_public_path__ + "static/media/login-logo.ae6a5931.svg";